// Define newsGrid globally before DOMContentLoaded
window.newsGrid = function() {
    return {
        allItems: [],
        displayedItems: [],
        filteredItems: [],
        page: 1,
        perPage: 12,
        loading: false,

        async init() {
            const initialData = JSON.parse(this.$el.dataset.initialItems);
            this.allItems = initialData;

            // Apply initial filter based on URL
            this.applyYearFilter();

            // Set up intersection observer after initial render
            this.$nextTick(() => {
                this.setupInfiniteScroll();
                this.setupYearFilter();
            });
        },

        setupYearFilter() {
            const yearFilter = document.getElementById('yearFilter');
            if (yearFilter) {
                yearFilter.addEventListener('change', (e) => {
                    const url = new URL(window.location.href);
                    if (e.target.value) {
                        url.searchParams.set('year', e.target.value);
                    } else {
                        url.searchParams.delete('year');
                    }
                    window.history.pushState({}, '', url.toString());
                    this.applyYearFilter();
                });
            }
        },

        applyYearFilter() {
            const queryParams = new URLSearchParams(window.location.search);
            const selectedYear = queryParams.get('year');

            if (selectedYear) {
                this.filteredItems = this.allItems.filter(item => item.year === selectedYear);
            } else {
                this.filteredItems = [...this.allItems];
            }

            // Reset pagination and update display
            this.page = 1;
            this.displayedItems = this.filteredItems.slice(0, this.perPage);
        },

        setupInfiniteScroll() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.loading) {
                        this.loadMore();
                    }
                });
            }, { rootMargin: '100px' });

            const sentinel = this.$refs.scrollSentinel;
            if (sentinel) {
                observer.observe(sentinel);
            }
        },

        async loadMore() {
            if (this.loading || this.displayedItems.length >= this.filteredItems.length) return;

            this.loading = true;
            await new Promise(resolve => setTimeout(resolve, 500));

            const start = this.page * this.perPage;
            const end = start + this.perPage;
            const newItems = this.filteredItems.slice(start, end);

            this.displayedItems = [...this.displayedItems, ...newItems];
            this.page++;
            this.loading = false;
        }
    }
};